import { ConfirmResult } from './confirmResult';

export class DialogFormResult<T> {
  public valid: ConfirmResult;
  public change: ConfirmResult;
  public entity: T;
}
